export enum PanelViewsList {
  intro = "intro",
  main = "main",
  openedCard = "opened-card",
  cardsByTag = "cards-by-tag",
  filteredCards = "filtered-cards",
}
